import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { getFunctions, getFunctionStatistics } from '@/store/function/actions';

import { selectFunctions } from '@/store/function/selectors';

import { Col, Row, Table, Tooltip } from 'antd';
import { HiOutlineBadgeCheck, HiOutlineClipboardCheck, HiOutlineClock } from 'react-icons/hi';

import { createSelector } from '@reduxjs/toolkit';
import PropTypes from 'prop-types';

import css2 from '../index.module.scss';
import css from './Views.module.scss';

export const ViewFunction = props => {
  const [filterFunction, setFilterFunction] = useState([]);

  useEffect(() => {
    props.getFunctionStatistics({ hasEmployees: true });
    props.getFunctions({ size: 1000 });
  }, []);

  useEffect(() => {
    if (props.allFunctions && Array.isArray(props.allFunctions.content)) {
      setFilterFunction(
        props.allFunctions.content.map(item => {
          const resultFunctions = {};
          resultFunctions.text = item.name;
          resultFunctions.value = item.name;
          return resultFunctions;
        })
      );
    }
  }, [props.allFunctions]);

  const getColumns = () => {
    const { t, hasFunction, hasCoins, txtFunction } = props;
    let columns = [];

    if (hasFunction === true) {
      columns.push({
        title: txtFunction,
        dataIndex: 'function',
        key: 'function',
        filters: filterFunction,
        filterMultiple: false,
        filterSearch: true,
      });
    }

    columns.push({
      title: t('users'),
      dataIndex: 'employees',
      key: 'employees',
      align: 'center',
      defaultSortOrder: 'descend',
      sorter: true,
    });

    if (hasCoins) {
      columns.push({
        title: t('score'),
        dataIndex: 'totalCoins',
        key: 'totalCoins',
        align: 'center',
        defaultSortOrder: 'descend',
        sorter: true,
      });
    }

    columns.push({
      title: t('statistics'),
      dataIndex: 'statistics',
      key: 'statistics',
      width: 180,
    });

    return columns;
  };

  const getData = () => {
    const { t, functions } = props;
    if (functions) {
      return functions.map(item => {
        if (item.name === null) {
          item.name = t('noData');
        }
        return {
          function: item.name,
          employees: item.numberOfEmployees,
          totalCoins: item.coins,
          statistics: (
            <div className={css2['userStatistics']}>
              <Tooltip placement='top' title={t('finished')}>
                <div className={css2['iconGreen']}>
                  <HiOutlineBadgeCheck />
                  &nbsp;{item.finished}
                </div>
              </Tooltip>

              <Tooltip placement='top' title={t('planned')}>
                <div className={css2['iconBlue']}>
                  <HiOutlineClock />
                  &nbsp;{item.planned}
                </div>
              </Tooltip>

              <Tooltip placement='top' title={t('created')}>
                <div className={css2['iconRed']}>
                  <HiOutlineClipboardCheck />
                  &nbsp;{item.created}
                </div>
              </Tooltip>
            </div>
          ),
          key: item.id,
        };
      });
    }
  };

  const onChangeTable = (pagination, filters, sorter) => {
    props.getFunctionStatistics({
      hasEmployees: true,
      page: pagination.current - 1 || 0,
      name: filters.hasOwnProperty('function') ? filters.function?.[0] : '',
      sort: sorter.columnKey ? `${sorter.columnKey},${sorter.order == 'ascend' ? 'desc' : 'asc'}` : '',
    });
  };

  const pagination =
    props.functionsTotal > props.functionsPageSize
      ? {
          current: props.functionsPageNumber + 1,
          total: props.functionsTotal,
          pageSize: props.functionsPageSize,
          showSizeChanger: false,
          responsive: true,
          hideOnSinglePage: true,
        }
      : false;

  const render = () => {
    return (
      <Row className={css['Views-tableWrapper']}>
        <Col span={24} style={{ padding: '1rem' }}>
          <Table
            // className={css['Views-table']}
            columns={getColumns()}
            dataSource={getData()}
            loading={props.isLoading}
            bordered={true}
            pagination={pagination}
            onChange={onChangeTable}
            scroll={{ x: true }}
          />
        </Col>
      </Row>
    );
  };
  return render();
};

ViewFunction.propTypes = {
  t: PropTypes.func,
  hasFunction: PropTypes.bool,
  isLoading: PropTypes.bool,
  getFunctionStatistics: PropTypes.func,
  functions: PropTypes.array,
  txtFunction: PropTypes.string,
  getFunctions: PropTypes.func,
  allFunctions: PropTypes.array,
};

const mapStateToProps = createSelector([selectFunctions], selectFunctions => ({
  functions: selectFunctions.functionStatistics,
  functionsTotal: selectFunctions.functionStatisticsTotal,
  functionsPageSize: selectFunctions.functionStatisticsPageSize,
  functionsPageNumber: selectFunctions.functionStatisticsPageNumber,
  allFunctions: selectFunctions.functions,
}));

const mapActionsToProps = {
  getFunctionStatistics,
  getFunctions,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation('colleague')(ViewFunction));
